
























































import { Component,PropSync, VModel } from "vue-property-decorator";
import Vue from "vue";
import ChatApi from "@/includes/Api/Chat.api";
import moment from 'moment'
import { UserInfoIntruders } from "@/includes/types/DashboardExtended/types";
import UserMainInfo from "piramis-base-components/src/components/UserMainInfo.vue";
import { errorNotification } from "@/includes/NotificationService";

@Component({
  components: {
    UserMainInfo
  },
  data() {
    return {
      moment
    }
  }
})
export default class ModalViolations extends Vue{
  @PropSync("countUsers") count!: number
  @VModel() isModal!: boolean
  isLoading: boolean = false
  pageSize = 10
  page: number = 1
  dataViolations: Array<UserInfoIntruders> = []

  created(){
    this.getIntruderUsers(10, 0)
  }

  onChangePage(page: number, limit: number) {
    this.getIntruderUsers(limit, (page-1) * limit)
  }

  onModalDelete(){
    this.$confirm({
      title: this.$t("dashboard_delete_modal_confirm_title").toString(),
      content: this.$t('dashboard_delete_modal_confirm_content', { count: this.count }).toString(),
      okText: this.$t("button_delete").toString(),
      cancelText: this.$t("journal_log_cancel").toString(),
      okType:"danger",
      onOk:() => {
        this.isLoading = true
        ChatApi.deleteMembers("tg", { chat_id: this.$store.state.chatState.chat.chat_id, state: "FaceControl" })
          .then(({ data }) =>{
            this.count = data.count
          })
          .catch(errorNotification)

        setTimeout(()=> {
          this.isModal = false
          this.isLoading = false
        }, 2000)
      }
    })
  }

  getIntruderUsers(limit: number, offset: number){
    ChatApi.getIntruders("tg", {
      chat_id: this.$store.state.chatState.chat.chat_id,
      limit: limit,
      offset: offset
    })
      .then(response => {
        this.dataViolations = response.data.members
      })
      .catch(errorNotification)
  }
}
